export default "__VITE_ASSET__DqNX9ytc__"